<template>
  <div
    class="relative w-full h-[300px]"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <apexchart
      v-if="series.length > 0"
      ref="chart"
      type="line"
      height="275%"
      :options="chartOptions"
      :series="series"
    />

    <!-- Hover Overlay -->
    <div
      v-if="!zoomEnabled && isHovered"
      class="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-50 backdrop-blur-sm cursor-pointer transition-opacity hover:bg-opacity-30"
      @click="enableZoom"
    >
      <span class="text-gray-900 font-semibold text-sm">Click to enable series zoom</span>
    </div>

    <!-- Chart Legend -->
    <div class="mt-4 flex justify-center space-x-6">
      <div class="flex items-center">
        <div class="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
        <span class="text-sm text-gray-600">Costs</span>
      </div>
      <div class="flex items-center">
        <div class="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
        <span class="text-sm text-gray-600">Deployments</span>
      </div>
      <div class="flex items-center">
        <div class="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
        <span class="text-sm text-gray-600">Alerts</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'CombinedMetricsGraphic',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      default: () => []
    },
    chartOptions: {
      type: Object,
      required: true
    },
    isHovered: {
      type: Boolean,
      default: false
    },
    zoomEnabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleMouseEnter () {
      this.$emit('hover', true)
    },
    handleMouseLeave () {
      this.$emit('hover', false)
    },
    enableZoom () {
      this.$emit('enable-zoom')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/AICards/TimeSeriesCard/CombinedMetrics/CombinedMetricsGraphic.vue